import { render, staticRenderFns } from "./DashboardMarketPP.vue?vue&type=template&id=40a6f228&"
import script from "./DashboardMarketPP.vue?vue&type=script&lang=js&"
export * from "./DashboardMarketPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports